export default "__VITE_ASSET__Cm$Z53fY__"